import { useMutation, useQuery } from '@tanstack/react-query';
import { requestHandler } from 'lib/api';
import { HTTP_METHODS } from 'lib/api/consts';
import { errorHandler } from 'lib/functions/errors';
import { Dispatch } from 'redux';

import { MUTATION_KEYS } from './consts';
import { CreateFormPruffConnect } from './types';

export const createSGRWarrantyRequest = (dispatch: Dispatch) =>
  useMutation({
    mutationKey: MUTATION_KEYS.CREATE,
    mutationFn: async (params: {
      data: CreateFormPruffConnect;
      secretId: string;
    }) => {
      const { data, secretId } = params;
      const response = await requestHandler({
        method: 'post',
        url: `internal/express/${secretId}/sgrWarrantyRequest`,
        dispatch,
        data,
      });
      if (response) return response.data;
    },
    onError: (error) => errorHandler(dispatch, error),
  });

export const submitSGRWarrantyRequest = (dispatch: Dispatch) =>
  useMutation({
    mutationKey: MUTATION_KEYS.SUBMIT,
    mutationFn: async (params: { id: number; secretId: string }) => {
      const { id, secretId } = params;
      const response = await requestHandler({
        method: 'put',
        url: `internal/express/${secretId}/sgrWarrantyRequest/${id}/submit`,
        dispatch,
      });
      if (response) return response.data;
    },
    onError: (error) => errorHandler(dispatch, error),
  });

export const getSGRWarrantyRequestFile = (
  dispatch: Dispatch,
  secretId: string,
  id: number,
) =>
  useQuery({
    queryKey: MUTATION_KEYS.GET_FILE,
    queryFn: async (): Promise<Blob | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/express/${secretId}/sgrWarrantyRequest/${id}/file`,
        dispatch,
        responseType: 'blob',
      });
      if (response) return response.data;
    },
    enabled: !!id,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });

export const getPublicSGRWarrantyRequestFile = async (
  dispatch: Dispatch,
  secretId: string,
  warrantyRequestId: number,
  clientIdentifier: string,
  principalIdentifier: string,
) => {
  const response = await requestHandler({
    method: HTTP_METHODS.GET,
    url: `public/express/${secretId}/sgrWarrantyRequestFile/${warrantyRequestId}/${clientIdentifier}/${principalIdentifier}`,
    dispatch,
    responseType: 'arraybuffer',
  });
  if (response) {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return {
      blob: blob,
      contentType: 'application/pdf',
    };
  }
};
